import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

/**
 * SectionRouter
 *
 * Listens for `?section=sectionId` in the URL (set when navigating from
 * another route like /project/:id back to the home page).
 * Once the component mounts and the section element exists in the DOM,
 * it scrolls there and cleans the query param from the URL.
 */
const SectionRouter = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const sectionId = params.get('section');
        if (!sectionId) return;

        // Wait a tick for DOM + SmoothScroll to settle
        const timer = setTimeout(() => {
            const el = document.getElementById(sectionId);
            if (!el) return;

            const rect = el.getBoundingClientRect();
            const scrollTarget = window.scrollY + rect.top;

            gsap.to(window, {
                scrollTo: scrollTarget,
                duration: 1.2,
                ease: 'power3.inOut',
            });

            // Clean URL without triggering a navigation/re-render
            const cleanUrl = window.location.pathname;
            window.history.replaceState({}, '', cleanUrl);
        }, 150);

        return () => clearTimeout(timer);
    }, [location.search]);

    return null;
};

export default SectionRouter;
